import React, { useState } from 'react';
import { GlobeIcon, CheckIcon, ChevronDownIcon } from 'lucide-react';
const languages = [{
  code: 'en',
  name: 'English',
  flag: '🇺🇸'
}, {
  code: 'es',
  name: 'Español',
  flag: '🇪🇸'
}, {
  code: 'fr',
  name: 'Français',
  flag: '🇫🇷'
}, {
  code: 'de',
  name: 'Deutsch',
  flag: '🇩🇪'
}, {
  code: 'pt',
  name: 'Português',
  flag: '🇵🇹'
}, {
  code: 'it',
  name: 'Italiano',
  flag: '🇮🇹'
}];
export function LanguageSelector() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);
  const toggleDropdown = () => setIsOpen(!isOpen);
  const selectLanguage = language => {
    setSelectedLanguage(language);
    setIsOpen(false);
  };
  return <div className="relative" data-id="element-3480" data-mp="394fhwi4a9tue">
      <button onClick={toggleDropdown} className="flex items-center p-2 rounded-lg text-blue-300 hover:text-white hover:bg-white/10 transition-colors" data-id="element-3481" data-mp="1ss0gt8ysc9at">
        <GlobeIcon size={18} className="mr-2" data-id="element-3482" data-mp="1xrwn5euygctj" />
        <span className="mr-1" data-id="element-3483" data-mp="3n142kycf302b">{selectedLanguage.flag}</span>
        <span className="hidden md:inline" data-id="element-3484" data-mp="3n1dx8z8epvec">
          {selectedLanguage.code.toUpperCase()}
        </span>
        <ChevronDownIcon size={16} className="ml-1" data-id="element-3485" data-mp="3j1bwqteer80n" />
      </button>
      {isOpen && <div className="absolute right-0 mt-2 w-48 bg-gradient-to-br from-slate-800 to-blue-900 rounded-lg shadow-lg overflow-hidden z-50 border border-white/10" data-id="element-3486" data-mp="up6p4rubws4">
          <div className="py-1" data-id="element-3487" data-mp="9u2dtqshs99o">
            {languages.map(language => <button key={language.code} className="flex items-center w-full px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors" onClick={() => selectLanguage(language)} data-id="element-3488" data-mp="9shi3xufyka8">
                <span className="mr-2" data-id="element-3489" data-mp="jjly90vusb6n">{language.flag}</span>
                <span className="flex-1 text-left" data-id="element-3490" data-mp="el0yf2kijtiq">{language.name}</span>
                {selectedLanguage.code === language.code && <CheckIcon size={16} className="text-blue-400" data-id="element-3491" data-mp="tjctx5w5gw8b" />}
              </button>)}
          </div>
        </div>}
    </div>;
}